import { Start } from './Start';
import { Add } from './Add';
import { Select } from './Select';
import { Admin } from './Admin';
import { Edit } from './Edit';
import { Complete } from './Complete';

export default Start
export { Start, Add, Select, Admin, Edit, Complete }



// WEBPACK FOOTER //
// ./src/components/Profile/index.jsx